'use client';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';

const ElementPropsContext = React__default.createContext(null);
const ElementPropsProvider = ({
  children,
  elementProps
}) => {
  return jsx(ElementPropsContext.Provider, {
    value: elementProps,
    children: children
  });
};

export { ElementPropsContext, ElementPropsProvider };
//# sourceMappingURL=ElementPropsProvider.js.map
